import { LinearGradient } from "expo-linear-gradient";
import { StyleSheet } from "react-native";
import { Text } from "react-native-paper";

import { courseTheme, courseShadow } from "@/lib/training/courseTheme";

// Navy gradient module-intro banner — the source HTML's .mhero
// (CPR_Course_Module1.html / orientation preview intro, line 129). Used by the
// content screen when `hero` is set, so a module opens on the branded banner
// instead of the plain kicker/title/lede header.

export function ModuleHero({ mn, title, sub }: { mn: string; title: string; sub: string }) {
    return (
        <LinearGradient
            colors={["#0B2D4D", "#123A5E", "#0E4F56"]}
            locations={[0, 0.6, 1]}
            start={{ x: 0.15, y: 0 }}
            end={{ x: 0.85, y: 1 }}
            style={[styles.hero, courseShadow.card]}
        >
            <Text style={styles.mn}>{mn}</Text>
            <Text style={styles.title}>{title}</Text>
            <Text style={styles.sub}>{sub}</Text>
        </LinearGradient>
    );
}

const styles = StyleSheet.create({
    hero: { borderRadius: 24, paddingVertical: 24, paddingHorizontal: 22, overflow: "hidden" },
    mn: {
        fontSize: 12,
        fontWeight: "700",
        letterSpacing: 1.5,
        textTransform: "uppercase",
        color: courseTheme.tealL
    },
    title: { fontSize: 27, fontWeight: "800", color: "#FFFFFF", lineHeight: 30, marginTop: 7 },
    sub: { fontSize: 13.5, lineHeight: 20, color: "#CFE6E2", marginTop: 10 }
});
